namespace TabAurous.Scheme {
    export interface SchemePaymentRow {
        SchemePaymentId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        POSCustomerId?: number;
        SchemeId?: number;
        LedgerId?: number;
        Amount?: number;
        CustomerName?: string;
        FirstName?: string;
        PosCustomerCode?: string;
        Address?: string;
        Mobile?: number;
        PanNumber?: string;
        SchemeCode?: string;
        LedgerName?: string;
        SchemePaymentDetails?: SchemePaymentDetailsRow[];
    }

    export namespace SchemePaymentRow {
        export const idProperty = 'SchemePaymentId';
        export const localTextPrefix = 'Scheme.SchemePayment';
        export const deletePermission = 'Scheme:Payment:Delete';
        export const insertPermission = 'Scheme:Payment:Add';
        export const readPermission = '*';
        export const updatePermission = 'Scheme:Payment:Edit';

        export declare const enum Fields {
            SchemePaymentId = "SchemePaymentId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            POSCustomerId = "POSCustomerId",
            SchemeId = "SchemeId",
            LedgerId = "LedgerId",
            Amount = "Amount",
            CustomerName = "CustomerName",
            FirstName = "FirstName",
            PosCustomerCode = "PosCustomerCode",
            Address = "Address",
            Mobile = "Mobile",
            PanNumber = "PanNumber",
            SchemeCode = "SchemeCode",
            LedgerName = "LedgerName",
            SchemePaymentDetails = "SchemePaymentDetails"
        }
    }
}
